import service from '@/store/services/workshop/service_master-service';

const state = {
  list: {},
  service_master: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, service_master) => {
    state.service_master = service_master;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get_by_category({commit, dispatch}, params) {
    return service.list_service_by_category(params)
      .then((service_master) => { commit('SET_RESOURCE', service_master); });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((service_master) => { commit('SET_RESOURCE', service_master); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((service_master) => { commit('SET_RESOURCE', service_master); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((service_master) => { commit('SET_RESOURCE', service_master); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  service_master: state => state.service_master,
  page: state => state.meta.page,
};
 
const service_master = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default service_master;
